const frontendURL = '/cat/street/';
const backendURL = '/api/references/street/';
const name = 'Вулиці';

const instance = {
  frontendURL,
  backendURL,
  name,
  useHierarchyPagination: false,
};
export default instance;
